import React from 'react';

import AdminPanel from '../../../../assets/icons/ReactSvg/AdminPanel';
import '../Landing.css';

import { Grid, List, ListItem, ListItemText, Divider, Typography, Card, CardContent } from '@material-ui/core';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import testimonialsSection from '../testimonialsStyle';
import userStyles from '../styles/usersStyle';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    height: '100%',
  },
  media: {
    height: 140,
  },
  mediaHeader: {
    height: 240,
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightBold,
  },
  headingNormal: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: theme.typography.fontWeightRegular,
  },
  ...testimonialsSection,
  block: {
    minHeight: '100%',
    margin: '0 auto',
    padding: '10px 20px',
    maxWidth: '360px',
    textAlign: 'center',
    border: '1px solid #586a91',
    position: 'relative',
    backgroundColor: '#fff',
  },
  icon: {
    float: 'none',
    top: '-30px',
    left: '50%',
    transform: 'translateX(-50%)',
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '61px',
    height: '61px',
    position: 'absolute',
    backgroundColor: '#f2f5f9',
    borderRadius: '50%',
  },
  textBlock: {
    overflow: 'hidden',
  },
  mybutton: {
    borderRadius: '50%',
    overflow: 'hidden',
    pointerEvents: 'none',
    border: '1px solid #263d70',
    position: 'absolute',
    bottom: '-12px',
    left: '50%',
    transform: 'translateX(-50%)',
    padding: '0',
  },
  expandButton: {
    color: '#263d70',
    borderRadius: '50%',
    backgroundColor: '#f2f5f9',
  },
  title: {
    // color: 'red',
  },
  boldText: { fontWeight: 'bold' },
}));

const Roles = (props) => {
  const { classes } = props;
  const expClasses = useStyles();
  return (
    // {/* Roles */}
    <div className={classes.person} id="roles">
      <div className={classes.container}>
        <Grid container justify="center" spacing={8}>
          <Grid item xs={12} sm={12} md={10} className={`${classes.mlAuto} ${classes.mrAuto} ${classes.textCenter}`}>
            <h2 className={expClasses.title}>
              Ролі користувачів програмного комплексу «Інтегрована інформаційна система «Соціальна громада» та їх
              функції
            </h2>
          </Grid>
          <Grid container justify="center">
            <Grid item xs={12} sm={12} md={8}>
              <Card>
                <CardContent>
                  <Typography variant="h5" component="h2" style={{ textAlign: 'center' }}>
                    Ролі користувачів та їх функції
                  </Typography>
                  <Typography style={{ textAlign: 'center' }}>
                    В залежності від того, в якому особистому кабінеті виконується реєстрація в системі, користувачу
                    автоматично надаються роль та функції, які він може виконувати.
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={12} md={4} className={`${classes.mlAuto} ${classes.mrAuto} ${classes.textCenter}`}>
            <div className={expClasses.block}>
              {/* <div className={expClasses.icon}>
                <AdminPanel />
              </div> */}
              <div className={expClasses.textBlock}>
                <h4 className={classes.title}>Роль користувача:</h4>
                <p className={classes.description}>
                  <i>
                    Користувач в СО (старостинських округ) – <b>userSta</b>
                  </i>
                </p>
                <p className={classes.description}>
                  Заяви можуть бути прийняті від заявників свого СО та будь якого СО громади
                </p>
                <p className={classes.description}>
                  При реєстрації в системі необхідно вказати адресу крипто пошти з маскою <b>sta*********@ioc.gov.ua</b>
                </p>
                <Divider variant="middle" />
                <h4 className={classes.title}>Функції користувача:</h4>
                <List>
                  <ListItem>
                    <ListItemText
                      disableTypography
                      primary={
                        <Typography type="body2">
                          Формування електронної заяви в межах відповідного СО користувачем <b>userSta</b>;
                        </Typography>
                      }
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      disableTypography
                      primary={<Typography type="body2">Формування електронної анкети;</Typography>}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      disableTypography
                      primary={
                        <Typography type="body2">
                          Коригування даних електронної заяви, створеної в межах відповідного СО користувачем{' '}
                          <b>userSta</b>;
                        </Typography>
                      }
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      disableTypography
                      primary={
                        <Typography type="body2">
                          Перегляд журналу звернень, який складається із заяв, створених в межах відповідного СО
                          користувачем <b>userSta</b>;
                        </Typography>
                      }
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      disableTypography
                      primary={<Typography type="body2">Передача електронних заяв на перевірку в ТГ;</Typography>}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      disableTypography
                      primary={<Typography type="body2">Перегляд результатів опрацювання заяв в СПСЗН</Typography>}
                    />
                  </ListItem>
                </List>
              </div>
            </div>
          </Grid>
          {/* 2 */}
          <Grid item xs={12} sm={12} md={4} className={`${classes.mlAuto} ${classes.mrAuto} ${classes.textCenter}`}>
            <div className={expClasses.block}>
              {/* <div className={expClasses.icon}>
                <AdminPanel />
              </div> */}
              <div className={expClasses.textBlock}>
                <h4 className={classes.title}>Роль користувача:</h4>
                <p className={classes.description}>
                  <i>
                    Користувач в ЦНАП – <b>userCnap</b>
                  </i>
                </p>
                <p className={classes.description}>
                  При реєстрації в системі необхідно вказати адресу крипто пошти з маскою <b>cnap*******@ioc.gov.ua</b>
                </p>
                <Divider variant="middle" />
                <h4 className={classes.title}>Функції користувача:</h4>
                <List>
                  <ListItem>
                    <ListItemText
                      disableTypography
                      primary={
                        <Typography type="body2">
                          Формування електронної заяви в межах відповідного СО користувачем <b>userCnap</b>;
                        </Typography>
                      }
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      disableTypography
                      primary={<Typography type="body2">Формування електронної анкети;</Typography>}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      disableTypography
                      primary={
                        <Typography type="body2">
                          Коригування даних електронної заяви,створеної в межах відповідного СО користувачем{' '}
                          <b>userCnap</b>;
                        </Typography>
                      }
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      disableTypography
                      primary={
                        <Typography type="body2">
                          Перегляд журналу звернень, який складається із заяв, створених в межах відповідного СО
                          користувачем <b>userCnap</b>;
                        </Typography>
                      }
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      disableTypography
                      primary={<Typography type="body2">Передача електронних заяв на перевірку в ТГ;</Typography>}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      disableTypography
                      primary={<Typography type="body2">Перегляд результатів опрацювання заяв в СПСЗН</Typography>}
                    />
                  </ListItem>
                </List>
              </div>
            </div>
          </Grid>
          {/* 3 */}
          <Grid item xs={12} sm={12} md={4} className={`${classes.mlAuto} ${classes.mrAuto} ${classes.textCenter}`}>
            <div className={expClasses.block}>
              {/* <div className={expClasses.icon}>
                <AdminPanel />
              </div> */}
              <div className={expClasses.textBlock}>
                <h4 className={classes.title}>Роль користувача:</h4>
                <p className={classes.description}>
                  <i>
                    Користувач в територіальній громаді – <b>userOtg</b>
                  </i>
                </p>
                <p className={classes.description}>
                  При реєстрації в системі необхідно вказати адресу крипто пошти з маскою <b>otg*******@ioc.gov.ua</b>
                </p>
                <Divider variant="middle" />
                <h4 className={classes.title}>Функції користувача:</h4>
                <List>
                  <ListItem>
                    <ListItemText
                      disableTypography
                      primary={
                        <Typography type="body2">
                          Перегляд журналу звернень, який складається із заяв, створених в усіх СО громади користувачами{' '}
                          <b>userSta, userCnap</b>;
                        </Typography>
                      }
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      disableTypography
                      primary={
                        <Typography type="body2">
                          Перевірка сформованих електронних заяв в усіх СО громади користувачами{' '}
                          <b>userSta, userCnap</b>, крім заяв, створених користувачами{' '}
                          <b>super_userSta, super_userCnap</b>;
                        </Typography>
                      }
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      disableTypography
                      primary={
                        <Typography type="body2">
                          Передача перевірених електронних заяв на опрацювання в СПСЗН або на доопрацювання в СО;
                        </Typography>
                      }
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText
                      disableTypography
                      primary={<Typography type="body2">Перегляд результатів опрацювання заяв в СПСЗН;</Typography>}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText disableTypography primary={<Typography type="body2">Формування звітів</Typography>} />
                  </ListItem>
                </List>
              </div>
            </div>
          </Grid>
        </Grid>
        <Grid container justify="center" spacing={8}>
          <Grid item xs={12} sm={12} md={12} className={`${classes.mlAuto} ${classes.mrAuto} ${classes.textCenter}`}>
            <Grid container justify="center" spacing={8}>
              <Grid item xs={12} sm={12} md={8}>
                <Card>
                  <CardContent>
                    <Typography variant="h5" component="h2" style={{ textAlign: 'center' }}>
                      Ролі користувачів з додатковими функціями
                    </Typography>
                    <Typography style={{ textAlign: 'center' }}>
                      Зареєстрованим користувачам крім функцій, передбачених умовами реєстрації, можуть бути надані
                      додаткові функції. Додаткові функції надаються користувачам Державним підприємством «Інформаційно
                      обчислювальний центр Міністерства соціальної політики України» за письмовим зверненням направленим
                      на електронну адресу <a href="mailto:otg@ioc.gov.ua">otg@ioc.gov.ua</a>
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
            <Grid container justify="center" spacing={8}>
              <Grid item xs={12} sm={12} md={4} className={`${classes.mlAuto} ${classes.mrAuto} ${classes.textCenter}`}>
                <div className={expClasses.block}>
                  {/* <div className={expClasses.icon}>
                <AdminPanel />
              </div> */}
                  <div className={expClasses.textBlock}>
                    <h4 className={classes.title}>Роль користувача:</h4>
                    <p className={classes.description}>
                      <i>
                        Користувач в СО з додатковою функцією – <b>super_userSta</b>
                      </i>
                    </p>
                    <p className={classes.description}>Додаткова функція це:</p>
                    <p className={classes.description}>передача перевірених електронних заяв на опрацювання в СПСЗН</p>
                    <Divider variant="middle" />
                    <h4 className={classes.title}>Функції користувача:</h4>
                    <List>
                      <ListItem>
                        <ListItemText
                          disableTypography
                          primary={
                            <Typography type="body2">
                              Формування електронної заяви в межах відповідного СО користувачем <b>super_userSta</b>;
                            </Typography>
                          }
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText
                          disableTypography
                          primary={<Typography type="body2">Формування електронної анкети;</Typography>}
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText
                          disableTypography
                          primary={
                            <Typography type="body2">
                              Коригування даних електронної заяви, створеної в межах відповідного СО користувачем{' '}
                              <b>super_userSta</b>;
                            </Typography>
                          }
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText
                          disableTypography
                          primary={
                            <Typography type="body2">
                              Перегляд журналу звернень, який складається із заяв, створених в СО користувачем{' '}
                              <b>super_userSta</b>;
                            </Typography>
                          }
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText
                          disableTypography
                          primary={
                            <Typography type="body2">
                              Перевірка сформованих електронних заяв створених в межах відповідного СО користувачем{' '}
                              <b>super_userSta</b>;
                            </Typography>
                          }
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText
                          disableTypography
                          primary={
                            <Typography type="body2">
                              Передача перевірених електронних заяв на опрацювання в СПСЗН;
                            </Typography>
                          }
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText
                          disableTypography
                          primary={<Typography type="body2">Перегляд результатів опрацювання заяв в СПСЗН</Typography>}
                        />
                      </ListItem>
                    </List>
                  </div>
                </div>
              </Grid>
              {/* 2 */}
              <Grid item xs={12} sm={12} md={4} className={`${classes.mlAuto} ${classes.mrAuto} ${classes.textCenter}`}>
                <div className={expClasses.block}>
                  {/* <div className={expClasses.icon}>
                <AdminPanel />
              </div> */}
                  <div className={expClasses.textBlock}>
                    <h4 className={classes.title}>Роль користувача:</h4>
                    <p className={classes.description}>
                      <i>
                        Користувач в ЦНАП з додатковою функцією – <b>super_userCnap</b>
                      </i>
                    </p>
                    <p className={classes.description}>Додаткова функція це:</p>
                    <p className={classes.description}>передача перевірених електронних заяв на опрацювання в СПСЗН</p>
                    <Divider variant="middle" />
                    <h4 className={classes.title}>Функції користувача:</h4>
                    <List>
                      <ListItem>
                        <ListItemText
                          disableTypography
                          primary={
                            <Typography type="body2">
                              Формування електронної заяви в межах відповідного СО користувачем <b>super_userCnap</b>;
                            </Typography>
                          }
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText
                          disableTypography
                          primary={<Typography type="body2">Формування електронної анкети;</Typography>}
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText
                          disableTypography
                          primary={
                            <Typography type="body2">
                              Коригування даних електронної заяви, створеної в межах відповідного СО користувачем{' '}
                              <b>super_userCnap</b>;
                            </Typography>
                          }
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText
                          disableTypography
                          primary={
                            <Typography type="body2">
                              Перегляд журналу звернень, який складається із заяв, створених в межах відповідного СО
                              користувачем <b>super_userCnap</b>;
                            </Typography>
                          }
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText
                          disableTypography
                          primary={
                            <Typography type="body2">
                              Перевірка сформованих електронних заяв створених в межах відповідного СО користувачем{' '}
                              <b>super_userCnap</b>;
                            </Typography>
                          }
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText
                          disableTypography
                          primary={
                            <Typography type="body2">
                              Передача перевірених електронних заяв на опрацювання в СПСЗН;
                            </Typography>
                          }
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText
                          disableTypography
                          primary={<Typography type="body2">Перегляд результатів опрацювання заяв в СПСЗН</Typography>}
                        />
                      </ListItem>
                    </List>
                  </div>
                </div>
              </Grid>
              {/* 3 */}
              <Grid item xs={12} sm={12} md={4} className={`${classes.mlAuto} ${classes.mrAuto} ${classes.textCenter}`}>
                <div className={expClasses.block}>
                  {/* <div className={expClasses.icon}>
                <AdminPanel />
              </div> */}
                  <div className={expClasses.textBlock}>
                    <h4 className={classes.title}>Роль користувача:</h4>
                    <p className={classes.description}>
                      <i>
                        Користувач в територіальній громаді з додатковими функціями – <b>super_userOtg</b>
                      </i>
                    </p>
                    <p className={classes.description}>Додаткові функції це:</p>
                    <p className={classes.description}>формування електронної заяви;</p>
                    <p className={classes.description}>формування електронної анкети;</p>
                    <p className={classes.description}>коригування даних електронної заяви</p>
                    <Divider variant="middle" />
                    <h4 className={classes.title}>Функції користувача:</h4>
                    <List>
                      <ListItem>
                        <ListItemText
                          disableTypography
                          primary={
                            <Typography type="body2">
                              Формування електронної заяви в межах відповідного СО користувачем <b>super_userOtg</b>;
                            </Typography>
                          }
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText
                          disableTypography
                          primary={<Typography type="body2">Формування електронної анкети;</Typography>}
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText
                          disableTypography
                          primary={
                            <Typography type="body2">
                              Коригування даних електронної заяви, створененої в межах відповідного СО користувачем{' '}
                              <b>super_userOtg</b>;
                            </Typography>
                          }
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText
                          disableTypography
                          primary={
                            <Typography type="body2">
                              Перегляд журналу звернень, який складається із заяв, створених в межах відповідних СО
                              користувачем <b>super_userOtg</b> та в усіх СО громади користувачами{' '}
                              <b>userSta, userCnap</b>;
                            </Typography>
                          }
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText
                          disableTypography
                          primary={
                            <Typography type="body2">
                              Перевірка сформованих електронних заяв в межах СО користувачами userSta, userCnap, крім
                              заяв, створених користувачами <b>super_userSta, super_userCnap</b>;
                            </Typography>
                          }
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText
                          disableTypography
                          primary={
                            <Typography type="body2">
                              Передача перевірених електронних заяв на опрацювання в СПСЗН;
                            </Typography>
                          }
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText
                          disableTypography
                          primary={
                            <Typography type="body2">
                              Передача на доопрацювання у відповідний СО електроних заяв створених користувачами{' '}
                              <b>userSta</b> або <b>userCnap</b>;
                            </Typography>
                          }
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText
                          disableTypography
                          primary={<Typography type="body2">Перегляд результатів опрацювання заяв в СПСЗН;</Typography>}
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText
                          disableTypography
                          primary={<Typography type="body2">Формування звітів</Typography>}
                        />
                      </ListItem>
                    </List>
                  </div>
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default withStyles(userStyles)(Roles);
